import { Pipe, PipeTransform } from '@angular/core';
// @ts-ignore
import moment from 'moment';

@Pipe({
  name: 'moment'
})
export class MomentPipe implements PipeTransform {

  transform(value: number): any {
    return moment(value).format('hh:mm a | MMM DD');
  }

}
